import * as actionTypes from '../actionTypes';

const initialState = {
    issues: null,
    activeIssues: null,
    currentIssue: null,
    issueStats: null,
    pagination: null,
};

const issueReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_ISSUES:
            return { ...state, issues: action.payload?.issues, pagination: action.payload?.pagination };
        case actionTypes.SET_ACTIVE_ISSUES:
            return { ...state, activeIssues: action.payload };
        case actionTypes.SET_ISSUE_BY_ID:
            return { ...state, currentIssue: action.payload };
        case actionTypes.SET_ISSUE_STATS:
            return { ...state, issueStats: action.payload };
        default:
            return state;
    }
};

export default issueReducer;
